import { useTranslation, Trans } from "react-i18next";

import s1 from '../../img/AboutUs/i1.svg'
import s2 from '../../img/AboutUs/i2.svg'
import s3 from '../../img/AboutUs/i3.svg'

function Discover() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
            <p className="text-[20px] xl:text-[48px] poppins font-[500] text-[#061A77] xl:max-w-[465px] leading-[1.2]"><Trans>{t('about_us.4')}</Trans></p>
            <div className="flex flex-col md:flex-row gap-[10px] xl:gap-[20px] mt-[20px] xl:mt-[40px]">
                <div className="bg-[#F0FAF9] rounded-[4px] h-[270px] md:h-[345px] flex-grow flex flex-col justify-center py-[20px] xl:py-[40px] xl:px-[30px] px-[20px]">
                    <div className="bg-[#65CDBF] rounded-[10px] flex-shrink-0 xl:w-[80px] xl:h-[80px] w-[60px] h-[60px] flex items-center justify-center">
                        <img src={s1} alt="" className="w-[30px] h-[30px] xl:w-[40px] xl:h-[40px]"/>
                    </div>
                    <p className="mt-[20px] xl:mt-[30px] text-[#1A0402] poppins text-[16px] xl:text-[20px] leading-[1.2] font-[500]">{t('about_us.5')}</p>
                    <p className="mt-[10px] xl:mt-[12px] md:max-w-[331px] text-[#000000B2] inter text-[14px]">{t('about_us.6')}</p>
                </div>
                <div className="bg-[#EFF2FE] rounded-[4px] h-[270px] md:h-[345px] flex-grow flex flex-col justify-center py-[20px] xl:py-[40px] xl:px-[30px] px-[20px]">
                    <div className="bg-[#637BF5] rounded-[10px] flex-shrink-0 xl:w-[80px] xl:h-[80px] w-[60px] h-[60px] flex items-center justify-center">
                        <img src={s2} alt="" className="w-[30px] h-[30px] xl:w-[40px] xl:h-[40px]"/>
                    </div>
                    <p className="mt-[20px] xl:mt-[30px] text-[#1A0402] poppins text-[16px] xl:text-[20px] leading-[1.2] font-[500]">{t('about_us.7')}</p>
                    <p className="mt-[10px] xl:mt-[12px] md:max-w-[331px] text-[#000000B2] inter text-[14px]">{t('about_us.8')}</p>
                </div>
                <div className="bg-[#F1F7FE] rounded-[4px] h-[270px] md:h-[345px] flex-grow flex flex-col justify-center py-[20px] xl:py-[40px] xl:px-[30px] px-[20px]">
                    <div className="bg-[#061A77] rounded-[10px] flex-shrink-0 xl:w-[80px] xl:h-[80px] w-[60px] h-[60px] flex items-center justify-center">
                        <img src={s3} alt="" className="w-[30px] h-[30px] xl:w-[40px] xl:h-[40px]"/>
                    </div>
                    <p className="mt-[20px] xl:mt-[30px] text-[#1A0402] poppins text-[16px] xl:text-[20px] leading-[1.2] font-[500] max-w-[206px]">{t('about_us.9')}</p>
                    <p className="mt-[10px] xl:mt-[12px] md:max-w-[331px] text-[#000000B2] inter text-[14px]">{t('about_us.10')}</p>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Discover;
